const MOBILE_BREAKPOINT = 767;

export default {
  init() {
    const lists = document.querySelectorAll('.js-faq');

    if (!lists.length) {
      return;
    }

    lists.forEach(list => {
      const items = list.querySelectorAll('.js-faq-item');

      if (!items.length) {
        return;
      }

      /*
       * The js- hooks are this component's contract; the BEM block the state
       * classes belong to is the caller's. `data-accordion-block` lets another
       * accordion -- the Best template's `.best-compare` -- reuse the whole of
       * this behaviour without borrowing the FAQ's class names. Absent, it is
       * the FAQ, so nothing about that section changes.
       */
      const block = list.getAttribute('data-accordion-block') || 'faq';

      // Take the answers over only once JS is running, so a failed bundle
      // leaves them expanded rather than permanently hidden.
      list.classList.add(`${block}__list--ready`);

      const setHeight = item => {
        const answer = item.querySelector('.js-faq-answer');

        if (!answer) {
          return;
        }

        answer.style.maxHeight = item.classList.contains(`${block}__item--open`)
          ? `${answer.scrollHeight}px`
          : '';
      };

      const setOpen = (item, open) => {
        const button = item.querySelector('.js-faq-toggle');

        if (open) {
          item.classList.add(`${block}__item--open`);
        } else {
          item.classList.remove(`${block}__item--open`);
        }

        if (button) {
          button.setAttribute('aria-expanded', open ? 'true' : 'false');
        }

        setHeight(item);
      };

      items.forEach(item => {
        const button = item.querySelector('.js-faq-toggle');

        if (!button) {
          return;
        }

        // Desktop opens every item, except any the editor marked to start
        // collapsed. Mobile keeps them all closed regardless, with no option.
        const startCollapsed =
          item.getAttribute('data-start-collapsed') === '1';

        setOpen(item, !startCollapsed && window.innerWidth > MOBILE_BREAKPOINT);

        button.addEventListener('click', () => {
          setOpen(item, !item.classList.contains(`${block}__item--open`));
        });
      });

      // Reflowed text changes the answer height, so re-measure what is open.
      window.addEventListener('resize', () => {
        items.forEach(setHeight);
      });
    });
  }
};
